import { EventI } from '@/store/calendar/state';

export interface Patient {
  userId: number;
}

export interface AppointmentI {
  patient?: Patient;
  start: number;
  end: number;
}

export interface AppointmentState {
  appointments: EventI[];
  appointment: EventI | null;
}

export const state: AppointmentState = {
  appointments: [],
  appointment: null,
};
